import React from 'react';

import { Field } from '@hrlogics/react-components/form';

import { QueryMode } from 'src/api';
import { AutocompleteField } from 'src/components/finalForm';
import { usePeosAutocomplete } from 'src/hooks/peo/usePeosAutocomplete';

import { InboxFilterFieldProps, InboxFilterFormFields } from '../types';

export const InboxFilterPEOField: React.FC<InboxFilterFieldProps> = ({ disabled }) => {
  const peosAutocompleteProps = usePeosAutocomplete({
    queryFilter: searchText => ({
      filter: { displayName: { contains: searchText, mode: QueryMode.Insensitive } },
    }),
  });

  return (
    <Field
      fullWidth
      component={AutocompleteField}
      name={InboxFilterFormFields.peo}
      label="PEO"
      disabled={disabled}
      multiple
      {...peosAutocompleteProps}
    />
  );
};
